import { render, staticRenderFns } from "./questionIndex.vue?vue&type=template&id=87b7db50&scoped=true&"
import script from "./questionIndex.vue?vue&type=script&lang=js&"
export * from "./questionIndex.vue?vue&type=script&lang=js&"
import style0 from "./questionIndex.vue?vue&type=style&index=0&id=87b7db50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b7db50",
  null
  
)

export default component.exports